import { ValidatorFn, ValidationErrors, AbstractControl, FormArray } from '@angular/forms';

export function requiredIfSingleValidator(formArray: FormArray, minControlsLength = 1): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    if (!formArray) {
      return null;
    }

    if (formArray.controls.length > minControlsLength && control.value.trim().length === 0) {
      return {
        requiredIfSingle: true,
      };
    }

    return null;
  };
}
